(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*global $, jQuery, alert, console*/

"use strict";

$(document).ready(function () {

    // ------ RELATED CONTENT -------
    var resourcesSection = $('.s-resources.section_left-grey');

    if (resourcesSection.length) {
        var tag = resourcesSection.data('tag');
        $.ajax({
            url: 'https://www.altoros.com/blog/mini-api?method=get-latest-resources-new&tag=' + tag,
            dataType: 'json'
        }).always(function (data) {

            if (typeof data.blogpost === "undefined") {
                resourcesSection.hide();
                return;
            }

            var resourcesWrap = $('.s-resources.section_left-grey .s-resources__content.custom-slider__arrows-slider-related.enter');
            resourcesWrap.empty();

            function CutOffText(text) {

                let sliced = text.slice(0, 70);
                if (sliced.length + 3 < text.length) {
                    sliced += '...';
                } else {
                    sliced = text;
                }

                return sliced;
            }

            resourcesWrap.append('<a class="s-resources__block slider_block" href="' + data.blogpost[0].url + '" target="">' +
                '<div class="custom-slider__num">01</div>' +
                '<div class="s-resources__descr">Blog posts</div>' +
                '<div class="s-resources__header">' +CutOffText(data.blogpost[0].title)+ '</div>' +
                '<div class="learn-more__link learn-more__link-purple">Learn more</div></a>');
            if (typeof data.webinar[0] !== "undefined") {
                resourcesWrap.append('<a class="s-resources__block slider_block" href="' + data.webinar[0].url + '" target="">' +
                    '<div class="custom-slider__num">02</div>' +
                    '<div class="s-resources__descr">Webinars</div>' +
                    '<div class="s-resources__header">' +CutOffText(data.webinar[0].title)+ '</div>' +
                    '<div class="learn-more__link learn-more__link-purple">Learn more</div></a>');
            }
            if (typeof data.resource[0] !== "undefined") {
                resourcesWrap.append('<a class="s-resources__block slider_block" href="' + data.resource[0].url + '" target="">' +
                    '<div class="custom-slider__num">03</div>' +
                    '<div class="s-resources__descr">Visuals and Research Papers</div>' +
                    '<div class="s-resources__header">' +CutOffText(data.resource[0].title)+ '</div>' +
                    '<div class="learn-more__link learn-more__link-purple">Learn more</div></a>');
            }
            if (typeof data.blogpost[1] !== "undefined") {
                resourcesWrap.append('<a class="s-resources__block slider_block" href="' + data.blogpost[1].url + '" target="">' +
                    '<div class="custom-slider__num">04</div>' +
                    '<div class="s-resources__descr">Blog posts</div>' +
                    '<div class="s-resources__header">' +CutOffText(data.blogpost[1].title)+ '</div>' +
                    '<div class="learn-more__link learn-more__link-purple">Learn more</div></a>');
            }
            if (typeof data.webinar[1] !== "undefined") {
                resourcesWrap.append('<a class="s-resources__block slider_block" href="' + data.webinar[1].url + '" target="">' +
                    '<div class="custom-slider__num">05</div>' +
                    '<div class="s-resources__descr">Webinars</div>' +
                    '<div class="s-resources__header">' +CutOffText(data.webinar[1].title)+ '</div>' +
                    '<div class="learn-more__link learn-more__link-purple">Learn more</div></a>');
            }
            if (typeof data.resource[1] !== "undefined") {
                resourcesWrap.append('<a class="s-resources__block slider_block" href="' + data.resource[1].url + '" target="">' +
                    '<div class="custom-slider__num">06</div>' +
                    '<div class="s-resources__descr">Visuals and Research Papers</div>' +
                    '<div class="s-resources__header">' +CutOffText(data.resource[1].title)+ '</div>' +
                    '<div class="learn-more__link learn-more__link-purple">Learn more</div></a>');
            }

            function controlSlickCustomRelatedArrowSlider() {
                if(document.querySelector('.custom-slider__arrows-slider-related') !== null){
                    $('.custom-slider__arrows-slider-related').each(function () {
                        let numberSlides = +$(this).attr('data-slide-show');
                        let prevArr = $(this).closest('.container').find('.s-slider-arrows__left');
                        let nextArr = $(this).closest('.container').find('.s-slider-arrows__right');

                            $(this).slick({
                                infinite: true,
                                prevArrow: prevArr,
                                nextArrow: nextArr,
                                slidesToShow: numberSlides,
                                slidesToScroll: 1,
                                variableWidth: false,
                                focusOnSelect: true,
                                autoplay: true,
                                autoplaySpeed: 3000,
                                pauseOnHover: true,
                                pauseOnFocus: true,
                                responsive: [
                                    {
                                        breakpoint: 1400,
                                        settings: {
                                            slidesToShow: 2,
                                        }
                                    },
                                    {
                                        breakpoint: 600,
                                        settings: {
                                            slidesToShow: 1
                                        }
                                    },
                                ]
                            });

                    });

                }
            }
            controlSlickCustomRelatedArrowSlider();
        });
    }
    // -------- RELATED CONTENT END --------

});

},{}]},{},[1])